import { render } from "./RegistrationVisa.vue?vue&type=template&id=501e1b99"
import script from "./RegistrationVisa.vue?vue&type=script&lang=js"
export * from "./RegistrationVisa.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\HOSAM\\Desktop\\LIBYA\\qr-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__